import "./PerformanceStandards.module.css";
import Header from "@/reusable_sections/Header";
import Philosophy from "./sections/Philosophy";
import Manufacturing from "./sections/Manufacturing";
import Footer from "@/reusable_sections/Footer";
export default function PerformanceStandardsPage() {
  return <div>
      <Header />
      <Philosophy />
      <Manufacturing />
      <Footer />
    </div>;
}